import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "mosaicCardModal",
  type: "object",
  title: "Mosaic Card Modal",
  fieldsets: [
    {
      name: "modal"
    }
  ],
  fields: [
    {
      name: "image",
      title: "Image",
      type: "imageWithAlt",
      options: { hotspot: true },
      validation: (Rule) => Rule.required()
    },
    {
      name: "title",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    },
    {
      name: "tagline",
      type: "multilingualArrayText",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      name: "description",
      type: "multilingualArrayText",
      validation: (Rule) => Rule.required()
    },
    {
      fieldset: "modal",
      name: "modalTitle",
      type: "multilingualArrayString",
      description: "if empty, the card title is shown"
    },
    {
      fieldset: "modal",
      name: "modalContent",
      type: "multilingualArrayBlockContent"
    }
  ],
  preview: {
    select: {
      title: "title",
      media: "image"
    },
    prepare({ title, media }) {
      return {
        title: multilingualStringPreview(title),
        subtitle: "modal",
        media
      };
    }
  }
});
